import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../Shared/Redux/store';
const initialState = {
  editClassData: null,
  isAddClassModalOpen: false,
  isAssignClassSubjectModalOpen: false,
  isAssignModalOpen: false,
};

const classSlice = createSlice({
  name: 'class',
  initialState,
  reducers: {
    setEditClassData: (state, action: PayloadAction<any>) => {
      state.editClassData = action.payload;
    },

    setIsAssignModalOpen: state => {
      state.isAssignModalOpen = !state.isAssignModalOpen;
    },

    setIsAddClassModalOpen: state => {
      state.isAddClassModalOpen = !state.isAddClassModalOpen;
    },
    setIsAssignClassSubjectModalOpen: state => {
      state.isAssignClassSubjectModalOpen =
        !state.isAssignClassSubjectModalOpen;
    },
  },
});

export const selectIsAddClassModalOpen = (state: RootState) =>
  state.class.isAddClassModalOpen;

export const selectIsAssignClassSubjectModalOpen = (state: RootState) =>
  state.class.isAssignClassSubjectModalOpen;

export const selectEditClassData = (state: RootState) =>
  state.class.editClassData;

export const selectIsAssignModalOpen = (state: RootState) =>
  state.class.isAssignModalOpen;

export const {
  setEditClassData,
  setIsAddClassModalOpen,
  setIsAssignModalOpen,
  setIsAssignClassSubjectModalOpen,
} = classSlice.actions;
export default classSlice.reducer;
